<template>
  <ul :class="listClassName">
    <li
      v-for="(item, key) in items"
      :key="key"
      :class="listItemClassName"
    >
      <div
        class="row c-items-center c-sm:c-items-start relative c-flex-grow-1 c-content-start c-sm:c-px-1 c-lg:c-px-0"
      >
        <!-- image -->
        <div class="col-3 c-sm:col-12">
          <div class="embed-responsive c-mb-0 c-rounded-sm">
            <RemoteImage
              :src="`https://img.mix.it/general_assets/categories/${item.image}`"
              img-class="embed-responsive-item relative image-contain"
              :alt="item.text"
            />
          </div>
        </div>
        <!-- text -->
        <div class="col c-sm:col-12 static c-sm:c-pt-1 c-lg:c-pt-2 static c-sm:text-center">
          <!-- Redirect mixit bars and bags from mixes to products -->
          <router-link
            v-if="item.kind === 'mixit_bars' || item.kind === 'fruit_bags'"
            :to="{ name: 'productsPath', params: { permalink: item.permalink } }"
            class="block stretched-link font-medium hover-underline c-leading-sm"
          >
            {{ item.text }}
          </router-link>
          <router-link
            v-else
            :to="{ name: item.name, params: { permalink: item.permalink } }"
            class="block stretched-link font-medium hover-underline c-leading-sm"
          >
            {{ item.text }}
          </router-link>
        </div>
        <!-- arrow icon -->
        <div class="col-auto c-sm:hidden">
          <i class="mi-chevron-r" />
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup>
import RemoteImage from '@/components/general/BaseRemoteImage.vue'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },

  id: {
    type: String,
    required: true,
    validator: (value) => {
      return ['mix', 'ready'].includes(value)
    },
  },
})
const listClassName =
  props.id === 'mix'
    ? 'row no-gutters mt-n2 c-sm:mt-n4 c-md:mt-n5 ml-n2 c-sm:ml-n4 c-md:ml-n5 c-lg:mt-n6 c-lg:ml-n6 c-xl:ml-n7 c-py-1 c-md:c-py-2 c-lg:c-py-3 c-mb-0 list-unstyled'
    : 'row no-gutters mt-n2 c-sm:mt-n4 c-md:mt-n5 c-lg:mt-n6 ml-n2 c-sm:ml-n4 c-md:ml-n5 c-py-1 c-md:c-py-2 c-lg:c-py-3 c-mb-0 list-unstyled'

const listItemClassName =
  props.id === 'mix'
    ? 'col-12 c-sm:col-4 c-md:col-3 c-xl:col-2 flex c-flex-col c-pt-2 c-sm:c-pt-4 c-md:c-pt-5 c-pl-2 c-sm:c-pl-4 c-md:c-pl-5 c-lg:c-pl-6 c-xl:c-pl-7'
    : 'col-12 c-sm:col-4 c-md:col-3 c-lg:col-2 col-17 flex c-flex-col c-pt-2 c-sm:c-pt-4 c-md:c-pt-5 c-lg:c-pt-6 c-pl-2 c-sm:c-pl-4 c-md:c-pl-5'
</script>

<style lang="scss">
@include media-breakpoint-up(c-xl){
	//7 na radek
	.col-17{
		@include make-col(math.div(12, 8), $grid-columns);
	}
}
</style>
